export default __webpack_public_path__ + "static/media/tennis.b2c9aa16.png";